// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
jQuery(function ($) {
	if (!window.setSmoothScroll) {
		// var headerHeight = 0; // ヘッダー追従でない場合 // if not header-following
		var headerHeight = $('header').innerHeight(); // ヘッダー追従の場合 // if header following
		$('a[href^="#"]').click(function () {
			var href = $(this).attr("href");
			var target = $(href == "#" || href == "" ? 'html' : href);
			if (target.length > 0) {
				var position = target.offset().top - headerHeight;
				$("html, body").animate({ scrollTop: position }, 550, "swing");
				return false;
			}
		});
	}
})


// ドロワーメニュー // Drawer menu
jQuery(function ($) {
	let set = window.innerWidth > 1000;
	$('.js-nav').hover(function () {
		if (set) {
			$(this).addClass('active');
			$(this).find('.l-nav__sub-menu').stop().fadeIn(300);
		}

	}, function () {
		if (set) {
			$(this).removeClass('active');
			$(this).find('.l-nav__sub-menu').stop().fadeOut(300);
		}
	});

	document.querySelectorAll('.js-nav__spTrigger').forEach(trigger => {
		if (trigger.nextElementSibling.classList.contains('js-nav__spTarget')) {
			trigger.addEventListener('click', function (e) {
				if (!set) {
					e.preventDefault();
					e.stopPropagation();
					const trgr = e.target.closest('.js-nav__spTrigger');
					const wrapper = trgr.closest('.js-nav')
					const target = wrapper.querySelector('.js-nav__spTarget');

					if (wrapper.classList.contains('active')) {
						wrapper.classList.remove('active');
						jQuery(target).stop().slideUp();
					} else {
						wrapper.classList.add('active');
						jQuery(target).stop().slideDown();
					}
				}


			}, false);
		}
	});

	window.addEventListener('resize', function (e) {
		set = window.innerWidth > 1000;
	});
});


// // Menu on smartphone
jQuery(function ($) {
	if ($('.l-hamburger').length > 0) {
		$('.l-hamburger').click(function () {
			var parentHeader = $(this).closest('header');
			var nav = parentHeader.find('nav');
			var bg = $('.drawer_bg', parentHeader);

			$(this).toggleClass('toggle_active');
			bg.fadeToggle();
			$('body').toggleClass('drawer_open');

			if ($(this).hasClass('toggle_active')) {
				nav.addClass('is_open');
				nav.removeClass('is_close');
			} else {
				nav.removeClass('is_open');
				nav.addClass('is_close');
			}
		});

		$('.drawer_bg').click(function () {
			var parentHeader = $(this).closest('header');
			var nav = parentHeader.find('nav');
			var bg = $('.drawer_bg', parentHeader);

			bg.fadeOut();
			$('.l-hamburger').removeClass('toggle_active');
			$('body').removeClass('drawer_open');
			nav.removeClass('is_open');
			nav.addClass('is_close');
		});

		// エリア内リンク用 // For links within an area
		$('nav a').on('click', function () {
			// if (window.innerWidth <= 768) {
			if ($('.l-hamburger:visible').length > 0) {
				$('.l-hamburger').click();
			}
		});
	}
});


// アコーディオンの起動 // Activate the accordion
jQuery(function ($) {
	if ($('.js-accordion dt').length > 0) {
		$(".js-accordion dt").click(function () {
			$(this).next("dd").slideToggle();
			$(this).toggleClass("is-open");
		});
	}
});


import './_modules/slider.js';